import { memo, useCallback } from 'react';
import { cn } from '@divlab/divanui';

import * as ModalWindows from '@Stores/ModalWindows';
import Img from '@UI/Img';
import styles from './Document.module.css';

import type { DocumentData } from '@Pages/PageWarranty/typings';
import type { FC, HTMLAttributes } from 'react';

export interface DocumentProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  document: DocumentData;
}

const Document: FC<DocumentProps> = (props) => {
  const { className, document, ...restProps } = props;

  const handleClick = useCallback(() => {
    ModalWindows.open('Document', { document });
  }, [document]);

  return (
    <div {...restProps} className={cn(styles.document, className)} onClick={handleClick}>
      <Img className={styles.image} src={document.src} alt='' />
      <div className={styles.title}>{document.title}</div>
    </div>
  );
};

export default memo(Document);
